import { z } from "zod";

export const JobStatusFilter = {
	ALL: "all",
	ACTIVE: "active",
	CLOSED: "closed",
} as const;

export type JobStatusFilter = (typeof JobStatusFilter)[keyof typeof JobStatusFilter];

export const JOB_STATUS_FILTERS = Object.values(JobStatusFilter) as readonly JobStatusFilter[];

export const jobStatusFilterSchema = z.enum(JobStatusFilter);
